import { CongressesService } from "@/client";
import { useQuery } from "@tanstack/react-query";

const congressMetaQueryKey = (congressId: string) => {
  return ["congress-meta", congressId] as const;
};

function useCongressMeta(congressId: string) {
  return useQuery({
    queryKey: congressMetaQueryKey(congressId),
    queryFn: () => CongressesService.getCongressMetadata({ congressId }),
  });
}

export { congressMetaQueryKey, useCongressMeta };
